<script lang="ts">
    import KpHorizontalSeparator from 'shared/ui-widgets/separator/KpHorizontalSeparator.svelte';
</script>

<KpHorizontalSeparator marginOverride="0px"/>